try{self['workbox:sw:4.1.0']&&_()}catch(e){}// eslint-disable-line